import bank from './bank'
import policy from './policy'

export default {
  name: 'BaseInfoFinancial',
  path: 'financial',
  meta: {
    label: 'financial',
    auth: 'financial'
  },
  component: {
    name: 'Financial',
    render(c) {
      return c('router-view')
    }
  },
  children: [bank, policy]
}
